exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sgr-main {\n  width: 100%;\n  height: 100vh; }\n  .sgr-main.admin > #root {\n    background: #ededed; }\n  .sgr-main .sgr-homepage {\n    margin: 0;\n    height: 100vh; }\n    .sgr-main .sgr-homepage .social-link {\n      position: fixed;\n      bottom: 0;\n      width: 100%;\n      height: 30px;\n      background: rgba(0, 0, 0, 0.5);\n      text-align: left;\n      padding-top: 5px;\n      z-index: 999; }\n      .sgr-main .sgr-homepage .social-link a {\n        color: white;\n        margin-right: 20px;\n        float: right; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/pages/home/HomePage.scss
// module id = 1431
// module chunks = 0